


















































































































































































































































































































































































































































































































































































































import {db} from "@/plugins/db";

import {Component, Mixins} from 'vue-property-decorator'
import {BasicMixin} from "@/mixins/AdminMixin"
import CardHeader from "@/components/CardHeader.vue";
import {questions, VOZ} from '@/plugins/Config'
import {ActivityInterface, ActivityItemInterface, EnumTextVoz} from "@/models/Activity"
import {mapState} from "vuex";
import * as firebase from "firebase";


@Component({
    components:{
        CardHeader
    },
    computed:{
        ...mapState({
            activity:(state: any) => state.activity.activity,
        })
    }
})
export default class CreatedClase extends Mixins(BasicMixin) {
    public dialog3 = false;

    public dialog2 = false;
    public edit2 = false;

    public itemForm: any = null;
    public numberActivities = 0;
    public formAddData: any[]= [];
    public formAddDataResponse: any[]= [];
    public formAdd = '';
    public formAddResponse = '';
    public formImage: any = null;
    public formImageUrlPreview = '';
    public formExamen = false;
    public uploadValue = 0;

    public ActivitiesItems: ActivityItemInterface[] = [];

    public Activity: ActivityItemInterface = {
        title: '',
        activityQuestion: {
            key: '',
            text: '',
        },
        question: '',
        response: '',
        key: '',
        note: '',
        english: false,
        file: {
            path: '',
            type: '',
            size: 0
        },
        text: EnumTextVoz.TEXTO_A_VOZ,
    };

    public questions = questions;
    public VOZ = VOZ;


    public headers = [
        {
            text: 'Titulo',
            align: 'left',
            sortable: true,
            value: 'title',
        },
        {
            text: 'Numero de actividad',
            align: 'left',
            sortable: true,
            value: 'order',
        },
        {
            text: 'Actividades',
            sortable: true,
            value: 'activities',
        },
        {
            text: '¿Examen?',
            sortable: true,
            value: 'exam',
        },
        {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'createdAt',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public clase: ActivityInterface = {
        order: 1,
        exam: false,
        id: '',
        title:'',
        activities:[]
    };

    deleteItem(item: ActivityInterface){
        this.$store.dispatch('deleteActivity', {id: item.id, data: item,  path: this.$route.params.id});
        this.text = 'Se ha eliminado la Actividad';
        this.snackbar = true;
    }
    openModal(edit: boolean, item: ActivityInterface | any){
        this.edit = edit;
        this.dialog = true;
        if (this.edit){
            this.idModel = item.id
        this.clase = {
                order: item.order,
                exam: item.exam,
                id: item.id,
                title: item.title
            };
        }
    }

    openModal2(edit2: boolean, model: ActivityInterface){
        this.dialog3 = false
        this.edit2 = edit2;
        this.formExamen = model.exam;
        this.idModel = model.id;
        this.dialog2 = true;
    }


    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editActivity', {id: this.idModel, data: this.clase,  paths: {path: this.$route.params.id}});
            this.text = 'Se ha editado la Actividad';
            this.dialog = false;
            this.snackbar = true;
        } else {
            const dataclase: any = {
                ...this.clase,
                path: this.$route.params.id
            };
            this.$store.dispatch('createClasesActivity', dataclase);
            this.text = 'Se ha editado la clase';
            this.dialog = false;
            this.snackbar = true;
        }
    }

    formSubmit2(){
        if (this.edit2){
            //this.$store.dispatch('editCollect', {id: this.idModel, data: this.clase, collection: 'activity'});
            this.text = 'Se ha editado la clase';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.ActivitiesItems = [];
            const dataclase: any = {
                path2:this.idModel,
                exam: this.formExamen,
                path: this.$route.params.id
            };


           if (this.Activity.activityQuestion.key === 'VERDADERO_Y_FALSO'){
               const data: ActivityItemInterface = {
                   activityQuestion: this.Activity.activityQuestion,
                   title: this.Activity.title,
                   question: this.Activity.question,
                   response: this.Activity.response
               };
               this.ActivitiesItems.push(data);

               this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

               this.text = 'Se ha agregado las actividades';
               this.dialog2 = false;
               this.snackbar = true;
           }

            if (this.Activity.activityQuestion.key === 'OPCION_MULTIPLE'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    key: this.formAddData,
                    question: this.Activity.question,
                    response: this.Activity.response
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'RELLENAR_FRASE'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    key: this.formAddData,
                    question: this.Activity.question,
                    response: this.Activity.response
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'BUSCAR_PAR'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    key: this.formAddData,
                    question: this.Activity.question,
                    response: this.Activity.response
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'QUE_HAY_ARCHIVO'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    question: this.Activity.question,
                    response: this.Activity.response,
                    file: this.Activity.file
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'TEXTO_VOZ'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    question: this.Activity.question,
                    response: this.formAddData,
                    text: this.Activity.text
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'ARCHIVO_MULTI_RESPUESTA'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    question: this.Activity.question,
                    response:  '',
                    file: this.Activity.file,
                    key: this.formAddData
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }

            if (this.Activity.activityQuestion.key === 'PREVIEW'){
                const data: ActivityItemInterface = {
                    activityQuestion: this.Activity.activityQuestion,
                    title: this.Activity.title,
                    question: this.Activity.question,
                    response:  '',
                    file: this.Activity.file
                };
                this.ActivitiesItems.push(data);

                this.$store.dispatch('addActivity', {paths: dataclase, data: this.ActivitiesItems});

                this.text = 'Se ha agregado las actividades';
                this.dialog2 = false;
                this.snackbar = true;
            }
        }
        this.closeModal()
    }

    changeActivity() {

        this.Activity.question = '';
        this.Activity.response = '';
        this.Activity.key = '';
        this.Activity.note = '';
        this.Activity.english = false;
        this.Activity.file = {
            path: '',
            type: '',
            size: 0
        };
        this.formAddDataResponse = [];
        this.formAddResponse = '';
        this.Activity.text = EnumTextVoz.TEXTO_A_VOZ;
        this.formImage = null;
        this.formImageUrlPreview = '';
        this.uploadValue = 0;
        this.formAddData = [];
        this.formAdd = '';

        if (this.Activity.activityQuestion.key === 'VERDADERO_Y_FALSO'){
            this.Activity.response = false;

        }
    }


    addFormAdd(){
        this.formAddData.push(this.formAdd)
        this.formAdd = '';
    }

    addFormAddResponse(){
        this.formAddDataResponse.push(this.formAddResponse);
        this.formAddResponse = '';
    }

    IndexResponse(i: number){
        this.Activity.response = i
    }

    stringToArray(){
        const activi = this.Activity.question;
        // @ts-ignore
        this.formAddData =  activi.split(" ")
    }

    previewImage(event: any) {
        this.formImage = event
        this.formImageUrlPreview = URL.createObjectURL(event);
    }

    uploadFile(){

        const storageRef= firebase.storage().ref(`activities/${new Date().getTime()}_${this.formImage.name}`).put(this.formImage);
        storageRef.on(`state_changed`,snapshot=>{
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{alert(error.message)},
            ()=>{this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.Activity.file.path = url;
                    this.Activity.file.name = this.formImage.name;
                    this.Activity.file.size = this.formImage.size;
                    this.Activity.file.type = this.formImage.type.split('/')[0];
                });
            }
        );

    }



    async comprobarActividad(item: ActivityInterface){

       const data = await db.doc('clases/'+ this.$route.params.id)
            .collection('activity').doc(item.id).collection('activities').get();
           if (data){
               this.formExamen = item.exam;
               this.numberActivities = data.docs.length;
               this.dialog3 =true;
               this.itemForm = item
           }

    }

    closeModal(){

        this.Activity.activityQuestion = {
            key: '',
            text: ''
        };

        this.formAddDataResponse = [];
        this.formAddResponse = '';
        this.Activity.title = '';
        this.Activity.question = '';
        this.Activity.response = '';
        this.Activity.key = '';
        this.Activity.note = '';
        this.Activity.english = false;
        this.Activity.file = {
            path: '',
            type: '',
            size: 0
        };
        this.formImage = null;
        this.formImageUrlPreview = '';
        this.Activity.text = EnumTextVoz.TEXTO_A_VOZ;

        this.uploadValue = 0;
        this.formAddData = [];
        this.formAdd = '';

        this.idModel = '';
        // @ts-ignore
        this.$refs.obs.reset();
    }


     async BindClasesActivity(){
        await this.$store.dispatch('bindActivity', {id:this.$route.params.id, order: 'desc'} )
    }
    created(){
        this.BindClasesActivity()
    }
}
